/**
 * Legacy document migration (Feature 31) — preview, then execute.
 *
 * Documents ingested before collections existed carry no audience and no
 * collection lineage, so retrieval cannot see them. Repair rewrites their
 * metadata in place, one `update_acl` task per document.
 *
 * The preview exists because the assignment grants real access to real
 * documents and cannot be undone from the previous state. Never call
 * `runLegacyMigration` without showing the operator what `previewLegacyMigration`
 * returned for the same body.
 */
import { apiPost } from '../client.js';
import type { LegacyMigrationAccepted, LegacyMigrationBody, LegacyMigrationPlan } from '../types.js';

export function previewLegacyMigration(
  body: LegacyMigrationBody,
): Promise<LegacyMigrationPlan> {
  return apiPost<LegacyMigrationPlan>('/api/v1/documents/legacy-migration/preview', body);
}

export function runLegacyMigration(
  body: LegacyMigrationBody,
): Promise<LegacyMigrationAccepted> {
  return apiPost<LegacyMigrationAccepted>('/api/v1/documents/legacy-migration', body);
}
